import { IBankAccount } from '@common/interfaces/bankAccount'
import { IApi } from '../../api'
import { createAction } from '../types'

export const prefix = 'bankAccount'

export const CREATE_REQUEST = `${prefix}/CREATE_REQUEST`
export const CREATE_SUCCESS = `${prefix}/CREATE_SUCCESS`
export const CREATE_FAILURE = `${prefix}/CREATE_FAILURE`

export const createBankAccount = createAction(
  (data: Partial<IBankAccount> & { clientId: string }) => ({
    type: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE],
    promise: (api: IApi) => api.bankAccount.create(data),
  }),
)

export const UPDATE_REQUEST = `${prefix}/UPDATE_REQUEST`
export const UPDATE_SUCCESS = `${prefix}/UPDATE_SUCCESS`
export const UPDATE_FAILURE = `${prefix}/UPDATE_FAILURE`

export const updateBankAccount = createAction((id: string, data: Partial<IBankAccount>) => ({
  type: [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
  promise: (api: IApi) => api.bankAccount.update(id, data),
}))

export const DELETE_REQUEST = `${prefix}/DELETE_REQUEST`
export const DELETE_SUCCESS = `${prefix}/DELETE_SUCCESS`
export const DELETE_FAILURE = `${prefix}/DELETE_FAILURE`

export const deleteBankAccount = createAction((id: string) => ({
  type: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE],
  promise: (api: IApi) => api.bankAccount.delete(id),
}))

export const LIST_REQUEST = `${prefix}/LIST_REQUEST`
export const LIST_SUCCESS = `${prefix}/LIST_SUCCESS`
export const LIST_FAILURE = `${prefix}/LIST_FAILURE`

export const listBankAccounts = createAction(
  (clientId: string, data: object, withBalances: boolean = false) => ({
    type: [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE],
    promise: (api: IApi) => api.bankAccount.list({ clientId, withBalances, ...data }),
  }),
)

export const LIST_BALANCES_REQUEST = `${prefix}/LIST_BALANCES_REQUEST`
export const LIST_BALANCES_SUCCESS = `${prefix}/LIST_BALANCES_SUCCESS`
export const LIST_BALANCES_FAILURE = `${prefix}/LIST_BALANCES_FAILURE`

export const listBankAccountBalances = createAction((ongoingReportingId: string) => ({
  type: [LIST_BALANCES_REQUEST, LIST_BALANCES_SUCCESS, LIST_BALANCES_FAILURE],
  promise: (api: IApi) => api.bankAccount.listBalances(ongoingReportingId),
}))

export const UNLINK_PLAID_REQUEST = `${prefix}/UNLINK_PLAID_REQUEST`
export const UNLINK_PLAID_SUCCESS = `${prefix}/UNLINK_PLAID_SUCCESS`
export const UNLINK_PLAID_FAILURE = `${prefix}/UNLINK_PLAID_FAILURE`

export const unlinkPlaidBankAccount = createAction((id: string) => ({
  type: [UNLINK_PLAID_REQUEST, UNLINK_PLAID_SUCCESS, UNLINK_PLAID_FAILURE],
  promise: (api: IApi) => api.bankAccount.unlinkPlaid(id),
}))

export const SET_CLOSED_REQUEST = `${prefix}/SET_CLOSED_REQUEST`
export const SET_CLOSED_SUCCESS = `${prefix}/SET_CLOSED_SUCCESS`
export const SET_CLOSED_FAILURE = `${prefix}/SET_CLOSED_FAILURE`

export const setBankAccountClosed = createAction((id: string, isClosed: boolean) => ({
  type: [SET_CLOSED_REQUEST, SET_CLOSED_SUCCESS, SET_CLOSED_FAILURE],
  promise: (api: IApi) => api.bankAccount.setClosed(id, isClosed),
}))
